import { CART } from "../../ActionType/Cart";

export const cart = (
  state = JSON.parse(localStorage.getItem("cart")) || [],
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case CART:
      return payload;
    default:
      return state;
  }
};
